"use strict";
var __read = (this && this.__read) || function (o, n) {
    var m = typeof Symbol === "function" && o[Symbol.iterator];
    if (!m) return o;
    var i = m.call(o), r, ar = [], e;
    try {
        while ((n === void 0 || n-- > 0) && !(r = i.next()).done) ar.push(r.value);
    }
    catch (error) { e = { error: error }; }
    finally {
        try {
            if (r && !r.done && (m = i["return"])) m.call(i);
        }
        finally { if (e) throw e.error; }
    }
    return ar;
};
var __spreadArray = (this && this.__spreadArray) || function (to, from) {
    for (var i = 0, il = from.length, j = to.length; i < il; i++, j++)
        to[j] = from[i];
    return to;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.trySpawnMonsterNextTo = exports.trySpawnObjectNextTo = exports.getOpenTileNextTo = exports.doFleeBasic = exports.doSeekTarget_MeleeBasic = exports.doWanderBasic = exports.moveOffIfTooManyUnitsHere = exports.getBestTileFlee = exports.getBestTileOneStepTowards = exports.getBestTileOneStep = exports.isNextTo = exports.canLineOfFire = exports.canSee = exports.findNearestOrPreferredTarget = void 0;
var diveColors_1 = require("@dive/colors/diveColors");
var diveParticles_sidecar_1 = require("@dive/effects/diveParticles-sidecar");
var diveObjects_sidecar_1 = require("@dive/entities/diveObjects-sidecar");
var diveObjectsData_sidecar_1 = require("@dive/entities/diveObjectsData-sidecar");
var diveTilemap_sidecar_1 = require("@dive/tilemap/diveTilemap-sidecar");
var diveTilemapPart_1 = require("@dive/tilemap/diveTilemapPart");
var diveTilemapUtils_sidecar_1 = require("@dive/tilemap/diveTilemapUtils-sidecar");
var lineAlgo_sidecar_1 = require("@dive/to-engine/lineAlgo-sidecar");
var distanceUtil_sidecar_1 = require("@lib/distanceUtil-sidecar");
var diveCrew_1 = require("@voyage/crew/diveCrew");
var diveCrew_sidecar_1 = require("@voyage/crew/diveCrew-sidecar");
var diveCrew_attackable_sidecar_1 = require("@voyage/crew/diveCrew_attackable-sidecar");
var diveCrew_hero_data_1 = require("@voyage/crew/diveCrew_hero_data");
var diveCrew_movable_sidecar_1 = require("@voyage/crew/diveCrew_movable-sidecar");
var diveAi_common_sidecar_1 = require("./diveAi_common-sidecar");
var enumsAi_1 = require("./enumsAi");
function findNearestOrPreferredTarget(obj, o) {
    var filter = function (c) { return true; };
    if (o.type === enumsAi_1.EAiTargetType.Hero) {
        filter = function (c) { return c.type === diveCrew_1.EVoyageCrewType.Hero; };
    }
    if (o.type === enumsAi_1.EAiTargetType.Enemy) {
        filter = function (c) { return c.type === diveCrew_1.EVoyageCrewType.Enemy; };
    }
    var targets = diveCrew_sidecar_1.diveCrew.getAllFiltered(filter);
    var closestTarget = null;
    var closestTargetDist = 9999;
    for (var iTarget = 0; iTarget < targets.length; iTarget++) {
        var target = targets[iTarget];
        // Can't target if they aren't on the level
        if (target.isDownStairs) {
            continue;
        }
        if (target.isUpStairs) {
            continue;
        }
        if (o.requireAlive) {
            if (target.isDead || target.isDying) {
                continue;
            }
            if (target.hitpoints <= 0) {
                continue; // TODO: better dead detection
            }
        }
        var dist = distanceUtil_sidecar_1.distanceUtil.distanceNormalIIJ(obj, target);
        if (dist > o.range) {
            continue;
        }
        var isPreferredTarget = obj.preferredTarget === target;
        // Preferred target doesn't need to be closest target
        if (!isPreferredTarget) {
            if (dist > closestTargetDist) {
                continue;
            }
        }
        if (o.requireVision) {
            if (!exports.canSee(obj, target)) {
                continue;
            }
        }
        if (o.requireLineOfFire) {
            if (!exports.canLineOfFire(obj, target)) {
                continue;
            }
        }
        closestTarget = target;
        closestTargetDist = dist;
        // Oh! prefer this one
        if (isPreferredTarget) {
            break;
        }
    }
    return closestTarget;
}
exports.findNearestOrPreferredTarget = findNearestOrPreferredTarget;
var canSee = function (m, mTarget) {
    // Expensive fov calculation to see if one monster can see the other
    // let visionRange = 7
    // let canSee = false
    // calculateMonsterVision(m, map, visionRange, (x, y, r, visibility) => {
    //   let m = rogueMonsters.getAt(x, y)
    //   if (m === mTarget) {
    //     canSee = true
    //   }
    // })
    // return canSee
    var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(mTarget.i, mTarget.j);
    if (!gs) {
        return false;
    }
    // TODO: make this more sophisticated
    if (!diveTilemapUtils_sidecar_1.diveTilemapUtils.isSpotVisibleToHero(gs)) {
        return false;
    }
    return true;
};
exports.canSee = canSee;
var canLineOfFire = function (m, mTarget) {
    var reachedTarget = false;
    lineAlgo_sidecar_1.lineAlgo.drawLineBresenham(m.i, m.j, mTarget.i, mTarget.j, function (pi, pj, c1, c2) {
        if (pi === mTarget.i && pj === mTarget.j) {
            reachedTarget = true;
            return false;
        }
        var gs = diveTilemap_sidecar_1.diveTilemap.getSafe(pi, pj);
        if (!gs) {
            return false;
        }
        // TODO: tile should have can shoot attribute
        if (!gs.tile1.canWalk) {
            return false;
        }
        return true;
    });
    return reachedTarget;
};
exports.canLineOfFire = canLineOfFire;
var isNextTo = function (m, mTarget) {
    return distanceUtil_sidecar_1.distanceUtil.isNextToIIJ(m, mTarget);
};
exports.isNextTo = isNextTo;
var getBestTileOneStep = function (m, hCalc) {
    var neighbors = __spreadArray([], __read(diveTilemapPart_1.neighbors4));
    m.rando.shuffle(neighbors);
    var gs = diveTilemap_sidecar_1.diveTilemap.getSafeIIJ(m);
    if (!gs) {
        return null;
    }
    var bestH = 99999;
    var bestTile = null;
    for (var i = 0; i < neighbors.length; i++) {
        var nIdx = neighbors[i];
        var neighbor = gs.neighbors[nIdx];
        if (neighbor) {
            if (!diveTilemapUtils_sidecar_1.diveTilemapUtils.isTileWalkable(neighbor)) {
                continue;
            }
            var h = hCalc(neighbor);
            if (h === null) {
                continue; // Not valid
            }
            if (h < bestH) {
                bestH = h;
                bestTile = neighbor;
            }
        }
    }
    if (bestTile) {
        return bestTile;
    }
    return null;
};
exports.getBestTileOneStep = getBestTileOneStep;
var getBestTileOneStepTowards = function (m, mTarget) {
    var hCalc = function (tp) {
        var h = 1;
        if (!mTarget) {
            // h += 1
        }
        else {
            h += distanceUtil_sidecar_1.distanceUtil.distanceNormalIIJ(tp, mTarget);
        }
        h += diveCrew_sidecar_1.diveCrew.countAtIJ(tp.i, tp.j) * 10;
        return h;
    };
    return exports.getBestTileOneStep(m, hCalc);
};
exports.getBestTileOneStepTowards = getBestTileOneStepTowards;
var getBestTileFlee = function (m, calcFleeTargetMultiplier, maxRange) {
    var targets = diveCrew_sidecar_1.diveCrew.getAllFiltered(function (c) {
        return calcFleeTargetMultiplier(c) > 0 &&
            distanceUtil_sidecar_1.distanceUtil.distanceNormalIIJ(m, c) <= maxRange;
    });
    var hCalc = function (tp) {
        var h = 1;
        for (var iTarget = 0; iTarget < targets.length; iTarget++) {
            var target = targets[iTarget];
            h +=
                maxRange +
                    2 -
                    distanceUtil_sidecar_1.distanceUtil.distanceNormalIIJ(tp, target) *
                        calcFleeTargetMultiplier(target);
        }
        h += diveCrew_sidecar_1.diveCrew.countAtIJ(tp.i, tp.j) * 10;
        return h;
    };
    return exports.getBestTileOneStep(m, hCalc);
};
exports.getBestTileFlee = getBestTileFlee;
var moveOffIfTooManyUnitsHere = function (obj, target) {
    // Are there too many monsters here?
    if (diveCrew_sidecar_1.diveCrew.countAtIJ(obj.i, obj.j) > 1) {
        // TODO: move off
        var nextTile = diveAi_common_sidecar_1.diveAi_common.getBestTileOneStepTowards(obj, target);
        if (nextTile) {
            diveCrew_movable_sidecar_1.diveCrew_movable.syncTryPathOffset(obj, nextTile.i - obj.i, nextTile.j - obj.j);
        }
        return true;
    }
    return false;
};
exports.moveOffIfTooManyUnitsHere = moveOffIfTooManyUnitsHere;
var doWanderBasic = function (obj) {
    // Wander
    var dirs4 = [
        [0, -1],
        [0, 1],
        [-1, 0],
        [1, 0],
    ];
    var dir = obj.rando.sample(dirs4);
    var oi = dir[0];
    var oj = dir[1];
    diveCrew_movable_sidecar_1.diveCrew_movable.syncTryPathOffset(obj, oi, oj);
};
exports.doWanderBasic = doWanderBasic;
var doSeekTarget_MeleeBasic = function (obj, target) {
    // Seek target
    if (diveAi_common_sidecar_1.diveAi_common.isNextTo(obj, target)) {
        // TODO: extract to attackable?
        // Attack
        diveCrew_attackable_sidecar_1.diveCrew_attackable.updateTick(obj, enumsAi_1.EAiTargetType.Hero); // TODO: skip getting target?
        //diveCrew_movable.sync_attack(obj, target)
        return;
    }
    else {
        var nextTile = diveAi_common_sidecar_1.diveAi_common.getBestTileOneStepTowards(obj, target);
        if (nextTile) {
            diveCrew_movable_sidecar_1.diveCrew_movable.syncTryPathOffset(obj, nextTile.i - obj.i, nextTile.j - obj.j);
        }
        return;
        // // Move next to target
        // let path = diveCrew_movable.sync_tryPathTo(
        //   obj,
        //   target.i,
        //   target.j,
        //   EDivePathToMode.NextTo,
        //   false,
        // )
        // if (path?.isSuccess) {
        //   diveCrew_movable.setNewPath(obj, path)
        // }
    }
};
exports.doSeekTarget_MeleeBasic = doSeekTarget_MeleeBasic;
var doFleeBasic = function (obj) {
    // console.log('doFleeBasic')
    var nextTile = diveAi_common_sidecar_1.diveAi_common.getBestTileFlee(obj, function (c) {
        return c.heroType === diveCrew_hero_data_1.EDiveHeroSubtype.None ? 0 : 1;
    }, 10);
    if (nextTile) {
        diveCrew_movable_sidecar_1.diveCrew_movable.syncTryPathOffset(obj, nextTile.i - obj.i, nextTile.j - obj.j);
        return;
    }
    exports.doWanderBasic(obj);
};
exports.doFleeBasic = doFleeBasic;
var getOpenTileNextTo = function (m, allowCrew) {
    var hCalc = function (tp) {
        var h = 1;
        if (!diveTilemapUtils_sidecar_1.diveTilemapUtils.isTileWalkable(tp)) {
            return null;
        }
        if (tp.objects.length > 0) {
            return null;
        }
        if (!allowCrew) {
            if (tp.crew.length > 0) {
                return null;
            }
        }
        // if(!filter(tp)) {
        //   return null
        // }
        return h;
    };
    return exports.getBestTileOneStep(m, hCalc);
};
exports.getOpenTileNextTo = getOpenTileNextTo;
var trySpawnObjectNextTo = function (obj, key, allowCrew, poof) {
    var tp = diveAi_common_sidecar_1.diveAi_common.getOpenTileNextTo(obj, allowCrew);
    if (tp) {
        var newObj = diveObjects_sidecar_1.diveObjects.create(0, diveObjectsData_sidecar_1.diveObjectsData.find(key));
        diveObjects_sidecar_1.diveObjects.moveToIJ(newObj, tp.i, tp.j);
        if (poof) {
            if (diveTilemapUtils_sidecar_1.diveTilemapUtils.isSpotVisibleToHero(tp)) {
                diveParticles_sidecar_1.diveParticles.createMultiple('poof', tp.x, tp.y, 5, diveColors_1.diveColors.pureWhite);
            }
        }
        return newObj;
    }
    return null;
};
exports.trySpawnObjectNextTo = trySpawnObjectNextTo;
var trySpawnMonsterNextTo = function (obj, enemyType, poof) {
    var tp = diveAi_common_sidecar_1.diveAi_common.getOpenTileNextTo(obj, false);
    if (tp) {
        var newMons = diveCrew_sidecar_1.diveCrew.createMonster(0, enemyType);
        diveCrew_sidecar_1.diveCrew.moveToIJ(newMons, tp.i, tp.j);
        if (poof) {
            if (diveTilemapUtils_sidecar_1.diveTilemapUtils.isSpotVisibleToHero(tp)) {
                diveParticles_sidecar_1.diveParticles.createMultiple('poof', tp.x, tp.y, 5, diveColors_1.diveColors.pureWhite);
            }
        }
        return newMons;
    }
    return null;
};
exports.trySpawnMonsterNextTo = trySpawnMonsterNextTo;
